import { render, staticRenderFns } from "./Nieuws.vue?vue&type=template&id=6a035940&scoped=true"
import script from "./Nieuws.vue?vue&type=script&lang=js"
export * from "./Nieuws.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a035940",
  null
  
)

export default component.exports